import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


interface IRouteGuard {
    conditions: boolean[];
    altRoute: string;       //the alternative route to go to, if a condition if not true
}

const RouteGuard: React.FC<IRouteGuard> = ({ conditions, altRoute }) => {

    const navigate = useNavigate();

    useEffect(() => {

        for (const condition of conditions) {
            if (!condition) {       //a condition is false
                // alert('tryin to guard ');
                navigate(altRoute, { replace: true });
            }
        }
    }, [conditions]);

    return null;
}

export default RouteGuard;